let BUGLOG_TOAST_CONTAINER = null;

function ensureContainer() {
    if (BUGLOG_TOAST_CONTAINER && document.body.contains(BUGLOG_TOAST_CONTAINER)) {
        return BUGLOG_TOAST_CONTAINER;
    }
    const div = document.createElement("div");
    div.className = "buglog-toast-wrapper";
    document.body.appendChild(div);
    BUGLOG_TOAST_CONTAINER = div;
    return BUGLOG_TOAST_CONTAINER;
}

function setText(el, text) {
    if (typeof text === "string") el.textContent = text;
}

/**
 * @param {Object} opts
 * @param {string} opts.title
 * @param {string} [opts.description]
 * @param {"success"|"error"} [opts.variant="success"]
 * @param {number} [opts.duration=2400]
 */
export function showToast(opts) {
    const container = ensureContainer();

    const {
        title,
        description,
        variant = "success",
        duration = 2400
    } = opts || {};

    const toast = document.createElement("div");
    toast.className = variant === "error" ? "buglog-toast error" : "buglog-toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");

    const icon = document.createElement("div");
    icon.className = "icon";
    setText(icon, variant === "error" ? "!" : "✓");

    const content = document.createElement("div");
    content.className = "content";

    const titleEl = document.createElement("div");
    titleEl.className = "title";
    setText(titleEl, title || "");

    content.appendChild(titleEl);

    if (description) {
        const descEl = document.createElement("div");
        descEl.className = "desc";
        setText(descEl, description);
        content.appendChild(descEl);
    }

    const close = document.createElement("button");
    close.className = "close";
    close.setAttribute("type", "button");
    close.setAttribute("aria-label", "Kapat");
    setText(close, "×");

    const bar = document.createElement("div");
    bar.className = "bar";

    toast.appendChild(icon);
    toast.appendChild(content);
    toast.appendChild(close);
    toast.appendChild(bar);

    container.appendChild(toast);

    const remove = () => {
        if (!toast.classList.contains("hide")) {
            toast.classList.add("hide");
            window.setTimeout(() => {
                if (toast.parentNode) toast.parentNode.removeChild(toast);
            }, 180);
        }
    };

    const timer = window.setTimeout(remove, duration);

    close.addEventListener("click", () => {
        window.clearTimeout(timer);
        remove();
    });

    toast.addEventListener("mouseenter", () => window.clearTimeout(timer));

    return remove;
}
